import { ReactElement } from 'react';

// `span` where only phrasing content is allowed, such as inside an `<output>`.
export const PopoverTextWrapper = ({
  children,
  as: Tag = 'p',
}: {
  children: ReactElement | string;
  as?: 'p' | 'span';
}) => {
  return (
    <Tag
      data-testid='tooltip--tooltip-message-container'
      className='block m-1 rounded-md bg-inverse p-3 text-negative text-body-s max-w-xs dark:shadow-black-1000/30 dark:shadow-md'>
      {children}
    </Tag>
  );
};
